import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { articles, articleImageMap } from '@/mocks/articles';

export default function ArticleGrid() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleArticleClick = (e: React.MouseEvent, slug: string) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/articoli/${slug}`);
  };

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <p className="text-foreground-950 font-heading text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
            {t('articles.title1')}
            <br />
            <span className="font-normal italic">{t('articles.title2')}</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/articoli/${article.slug}`}
              onClick={(e) => handleArticleClick(e, article.slug)}
              className="group block border border-background-200/60 rounded-2xl overflow-hidden hover:border-background-300/60 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] bg-background-100 overflow-hidden">
                <img
                  src={articleImageMap[article.slug]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <p className="text-xs text-foreground-400 mb-2">{article.date}</p>
                <h3 className="text-foreground-950 font-heading text-sm md:text-base font-semibold leading-snug group-hover:text-primary-600 transition-colors line-clamp-3">
                  {article.title}
                </h3>
                <p className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600">
                  {t('articles.readMore')}
                  <i className="ri-arrow-right-line"></i>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}